import { useQuery } from "@tanstack/react-query";
import { getPackagesForSelect } from "../../api/apiPackages";

const useGetPackagesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["packagesForSelect"],
        queryFn: getPackagesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetPackagesForSelect;
